// /stores/loader.js
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useLoaderStore = defineStore('loader', () => {
  const loading = ref(false)
  const message = ref('')

  function show(msg = 'Loading...') {
    loading.value = true
    message.value = msg
  }

  function hide() {
    loading.value = false
    message.value = ''
  }

  return { loading, message, show, hide }
})
